import Shrub from './components/Shrub';

function App() {
  return (
    <div data-testid="App" className="App">
      <Shrub />
    </div>
  );
}

export default App;
